import React from 'react'
import styled from 'styled-components'
import MainPage from '../../common/MainPage'
import FICColors from 'FICColors'
import FICTextButton from 'FICTextButton'
import Section from '../../common/Section'
import Article from '../../common/Article'
import { FBCommunityBanner } from 'help/common/customComponents'

export const MainPageDefault = styled(MainPage)`
  border-radius: unset;
  height: 100%;
  min-height: 100%;
  overflow: auto;
  .helpHeader{padding:0 10px 50px}
  .topHeader{
    width: 100%;
    max-width: 1200px;
    height: 80px;
    position: relative;
    margin: 0 auto;
    @media screen and (max-width: 799px){
      padding-top: 0;
      text-align: center;
    }
    .closeIcon{display: none}
    .logo{
      height: 32px;
      width: auto;
      left:0;
      @media screen and (max-width: 799px){
        position: relative;
        display: inline-block;
        left: unset;
      }
      @media (max-width: 425px) {
        height: 28px;
      }
    }
    .defaultTitle{
      position: absolute;
      left: 130px;
      top:34px;
      height: 28px;
      color:${FICColors.white};
      font-size: 20px;
      font-weight: 400;
      border-left: 2px solid rgba(255,255,255,0.5);
      padding-left: 24px;
      margin-left: 24px;
      padding-top: 5px;
      box-sizing: border-box;
      @media screen and (max-width: 799px){
        position: relative;
        display: inline-block;
        left: unset;
      }
      @media (max-width: 425px) {
        font-size: 16px;
        line-height: 27px;
        height: 32px;
        padding-left: 16px;
        margin-left: 16px;
        padding-top: 2px;
      }
    }
    .accessButton{
      position: absolute;
      right: 0;
      top:30px;
      .fic-text-button{
        height: 40px;
        @media all and (-ms-high-contrast: none) {
          min-height: 40px;
        }
        border: 2px solid ${FICColors.white};
        max-height: unset;
        box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        padding-top: 10px;
        text-transform: none;
        background-color: transparent;
        &:first-child{margin-right: 24px}
        &:hover{
          color: ${FICColors.white};
          background-color: rgba(255,255,255,0.24);
        }
      }
      @media screen and (max-width: 799px){
        display: none;
      }
    }
  }
`
const TopHeaderImpl = ({ className, ...props }) =>
  <div className={className}>
    {props.realm === 'fic' &&
    <FBCommunityBanner isExternal={props.isExternal} />
    }
    <div className='headerContainer'>
      {props.realm === 'fic'
        ? <img src='/img/logo-new-blue.png' srcSet='/img/logo-new-blue@2x.png 2x, /img/logo-new-blue@3x.png 3x' className='logo' onClick={() => props.changeView(undefined, 'main')} />
        : <img src='/img/logo-dipendenticloud-blue.png' className='logo' onClick={() => props.changeView(undefined, 'main')} style={{ height: 32 }} />
      }
      <h1 className='defaultTitle'>Supporto clienti</h1>
      <div className='accessButton'>
        <FICTextButton text='Prova Gratis' iconLeft={['fal', 'rocket']} href={props.realm === 'fic'
          ? 'https://www.fattureincloud.it/service/form/form-registrazione/' : 'https://secure.dipendentincloud.it/login?status=register'} />
        <FICTextButton text='Accedi' iconLeft={['fal', 'sign-in']} href={props.realm === 'fic'
          ? 'https://www.fattureincloud.it/service/form/form-login/' : 'https://secure.dipendentincloud.it/login?status=login'} />
      </div>
    </div>
  </div>

export const TopHeader = styled(TopHeaderImpl)`
  top: 0;
  width: 100%;
  z-index: 101;
  background-color: ${FICColors.white};
  color: ${FICColors.textDefault};
  border-bottom: 1px solid rgba(51,51,51,0.08);
  box-sizing: border-box;
  .headerContainer{
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    height: 100%;
    padding: 25px 0;
    box-sizing: border-box;
    @media screen and (max-width: 799px){
      text-align: center;
    }
    @media (max-width: 425px) {
      padding: 10px 0;
      img {
        height: 28px;
      }
    }
  }
  .logo{
      display: inline-block;
      margin-top: 5px;
      cursor: pointer;
    }
    .defaultTitle{
      display: inline-block;
      height: 33px;
      font-size: 20px;
      font-weight: 400;
      border-left: 2px solid rgba(0,0,0,0.3);
      padding-left: 24px;
      margin-left: 24px;
      padding-top: 6px;
      vertical-align: top;
      box-sizing: border-box;
      margin-top: 5px;
      color: rgba(51,51,51,0.8);
      @media (max-width: 425px) {
        font-size: 16px;
        line-height: 27px;
        height: 32px;
        padding-left: 16px;
        margin-left: 16px;
        padding-top: 2px;
      }
    }
    .accessButton{
      float: right;
      .fic-text-button{
        height: 40px!important;
        @media all and (-ms-high-contrast: none) {
          min-height: 40px;
        }
        max-height: unset!important;
        box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        padding-top: 10px!important;
        text-transform: none;
        background-color: #0294D3;
        border: 2px solid #0294D3;
        &:first-child{margin-right: 24px}
        &:nth-child(2){
          background-color: #fff;
          color: #0294D3;
          &:hover{
            background-color: #0294D3;
            color: ${FICColors.white};
          }
        }
        &:hover{
          background-color: ${FICColors.white};
          color: #0294D3;
          opacity: 1;
        }
      }
      @media screen and (max-width: 799px){
        display: none;
      }
    }
`

const SectionImpl = ({ className, realm, ...props }) => <div className={className}>
  <TopHeader changeView={props.changeView} realm={realm} isExternal={props.isExternal} />
  <Section {...props} realm={realm} className='section' />
</div>
export const SectionDefault = styled(SectionImpl)`
  height: 100%;
  .section{
    border-radius: unset;
    .sectionHeader{
      max-width: 940px;
      margin: 0 auto;
      padding: 50px 10px 0;
      @media (max-width: 425px) {
        padding-top: 25px;
      }
    }
    .breadCrumbs{padding: 0 10px}
    .breadCrumbsContainer{
      max-width: 940px;
      margin: 0 auto;
      position: relative;
      .autocomplete{
        right:0;
        height: 63px;
        &.open{
          width: 940px;
          max-width: 100%;
        }
        .faicon{margin: 0}
      }
    }
    .sectionListLoading{
      svg{margin: 0}
    }
    .separator{
      width: 940px;
      max-width: 100%;
      margin: 0 auto;
    }
  }
`

const FooterImpl = ({ className, ...props }) => <div className={className} />
export const Footer = styled(FooterImpl)`
  width: 100%;
  height: 10px;
  background-color: ${FICColors.defaultBlue};
  position: relative;
`

const ArticleImpl = ({ className, realm, ...props }) => <div className={className}>
  <TopHeader changeView={props.changeView} realm={realm} isExternal={props.isExternal} />
  <Article {...props} realm={realm} className='article' />
</div>
export const ArticleDefault = styled(ArticleImpl)`
  height: 100%;
  .article{
    border-radius: unset;
    .sectionHeader{
      max-width: 940px;
      margin: 0 auto;
      padding: 50px 10px 0;
      @media (max-width: 425px) {
        padding-top: 25px;
      }
    }
    .breadCrumbs{padding: 0 10px;}
    .breadCrumbsContainer{
      max-width: 940px;
      margin: 0 auto;
      position: relative;
      .autocomplete{
        right:0;
        height: 63px;
        &.open{
          width: 940px;
          max-width: 100%;
        }
        .faicon{
          margin: 0;
        }
      }
    }
    .articleContent{
      max-width: 940px;
      margin: 35px auto;
      padding: 0 10px;
      .subArticleContent{padding: 0 5px}
    }
  }
`



// WEBPACK FOOTER //
// ./src/help/external/js/customComponents.js